module.exports = __webpack_public_path__ + "img/sld_scb_18_t1_b1_green.0fd53133.svg";